import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
} from '@angular/router';
import { Globals } from 'src/app/common/globals';
import { CommonService } from '../services/common.service';

@Injectable({
    providedIn: 'root',
})
export class FacilityPermissionGuard {
    constructor(private globals: Globals, private router: Router, private commonService: CommonService,) { }

    facilityAdminRoute = ['facility'];
    facilityFinanceRoute = ['facility-store'];
    facilityRegisterRoute = ['register'];

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        // if user facility is null and trying to access facilityAdminRoute except facilityRegisterRoute
        if (this.globals.selectedFacility == null &&
            (this.facilityAdminRoute.includes(this.globals.currentLink.split('/')[1]) || this.facilityFinanceRoute.includes(this.globals.currentLink.split('/')[1])) &&
            !this.facilityRegisterRoute.includes(this.globals.currentLink.split('/')[2])) {
            this.commonService.showNotification('error', 'You do not have permission to access Facility Portal.');
            this.router.navigate(['/facility/register']);
            return false;
        }
        // if user facility is not null and trying to access facilityFinanceRoute without finance permission
        else if (this.globals.selectedFacility != null &&
            this.facilityAdminRoute.includes(this.globals.currentLink.split('/')[1]) &&
            !this.facilityRegisterRoute.includes(this.globals.currentLink.split('/')[2]) &&
            this.globals.selectedFacility.role.id == 2) {
            // this.commonService.showNotification('error', 'You do not have permission to access Facility Portal.');
            this.router.navigate(['/facility-store']);
            return false;
        } else if (this.globals.selectedFacility != null &&
            this.facilityAdminRoute.includes(this.globals.currentLink.split('/')[1]) &&
            !this.facilityRegisterRoute.includes(this.globals.currentLink.split('/')[2]) &&
            this.globals.selectedFacility.role.id == 3) {
            this.commonService.showNotification('error', 'You do not have permission to access Facility Portal.');
            this.router.navigate(['/professional']);
            return false;
        } else {
            return true;
        }
    }
}
